$(document).ready(function() {
    if ($('body').data('router-name') !== 'human-translator-checktext') {
        return;
    }

    window.ajaxLoadRow.initialize(window.checktextUrl, 5);
});
